import React from "react";
import { Draggable } from "react-beautiful-dnd";

class DraggableComponent extends React.Component {
  constructor(props) {
    super(props);
  }

  onChangeType = (e) => {
    e.persist();
    this.props.onChangeType(e.target.value);
  };

  render = () => {
    const { id, index, type, error, onDelete, children } = this.props;

    return (
      <Draggable key={id} draggableId={id} index={index}>
        {(provided, snapshot) => (
          <div
            ref={provided.innerRef}
            className={`draggable ${error ? "error" : ""} ${
              snapshot.isDragging ? "dragging" : ""
            }`}
            {...provided.draggableProps}
            style={provided.draggableProps.style}
          >
            <div className="draggable-handle" {...provided.dragHandleProps}>
              <div className="type-options">
                <label>Component Type: </label>
                <select
                  value={type}
                  onChange={this.onChangeType}
                  data-cy="component-select"
                >
                  {types.map(({ value, text }, i) => (
                    <option key={i} value={value}>
                      {text}
                    </option>
                  ))}
                </select>
              </div>
              <span
                onClick={onDelete}
                className="delete-icon"
                data-cy="remove-component"
              >
                <i className="fa fa-times" />
              </span>
            </div>
            <div className="draggable-content" style={{ padding: "20px" }}>
              {children}
            </div>
          </div>
        )}
      </Draggable>
    );
  };
}

const types = [
  {
    value: "text-content",
    text: "Text Area",
  },
  {
    value: "powerbi-component",
    text: "Power BI Component",
  },
  {
    value: "newsletter-modal-component",
    text: "Newsletter Modal",
  },
  {
    value: "related-posts",
    text: "Related Posts",
  },
  {
    value: "newsletter-signup",
    text: "Newsletter Signup",
  },
  {
    value: "image-upload-component",
    text: "Image",
  },
  {
    value: "html-embed",
    text: "HTML/Embed Component",
  },
  {
    value: "free-trial-modal",
    text: "Free Trial Modal",
  },
  {
    value: "free-report-request",
    text: "Free Report Request",
  },
];

export default DraggableComponent;
